<template>
  <div>
    <v-card v-if="reportData == null && !reportFlag">
                <span style="color: firebrick;font-weight: 800;" v-if="selectedTrade.bidExpirationTimeInDaysFromNow==0">متاسفانه، این سفارش منقضی شده و صرفاً جهت مشاهده شما نمایش داده می‌شود</span>
      <v-card-title>
        <!-- <v-row> -->

           
          <span class="Heading-6">
          دعوت نامه شرکت در
          {{
            selectedTrade && selectedTrade.request
              ? tradeRequestDisplayName(selectedTrade.request)
              : ''
          }}
        </span>
        <v-spacer />
        <!-- <v-col cols="12"> -->
        <span class="body-1">
          راهنمای شرکت در
          {{
            selectedTrade && selectedTrade.request
              ? tradeRequestDisplayName(selectedTrade.request)
              : ''
          }}
        </span>
        <HelperComponent
          helperId="how-to-reposne-trade-request"
          class="float-left"
        />
        <!-- </v-col> -->
        <!-- </v-row> -->
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-sheet outlined class="pa-4 mb-4">
          <v-row v-if="selectedTrade && selectedTrade.request">
            <v-col cols="12">
              <v-row class="pa-3">
                <v-col cols="12" md="4">
                  <label for="">نوع درخواست :</label>
                  <strong>
                    {{ tradeRequestDisplayName(selectedTrade.request) }}
                  </strong>
                </v-col>
                <v-col cols="12" md="4">
                  <label for="">حوزه درخواست :</label>
                  <strong>
                    {{ tradeCategoryDisplayName(selectedTrade.category) }}
                  </strong>
                </v-col>

                <v-col cols="12" md="4">
                  <label for="">تاریخ درخواست :</label>

                  <strong>
                    {{ selectedTrade.createdTimeUtc | moment }}
                  </strong>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                  v-if="selectedTrade.request != 'ContractorRecognition'"
                >
                  <label for="">تعداداقلام :</label>

                  <strong>
                    {{ selectedTrade.items.length }} (از درخواست
                    {{ selectedTrade.itemsCount }} قلمی،
                    {{ selectedTrade.items.length }} قلم مشمول این تقاضا
                    میباشد.)
                  </strong>
                </v-col>
                <v-col cols="12" md="8" v-else>
                  <label for="">عنوان :</label>

                  <strong>
                    {{ selectedTrade.content }}
                  </strong>
                </v-col>
                <v-col cols="12" md="4">
                  <label for=""
                    >مهلت شرکت در
                    {{ tradeRequestDisplayName(selectedTrade.request) }}
                    :</label
                  >
                  <strong
                    >{{ selectedTrade.bidExpirationTimeInDays }} روز ({{
                      selectedTrade.bidExpirationTimeInDaysFromNow != 0
                        ? selectedTrade.bidExpirationTimeInDaysFromNow +
                          'روز باقی مانده'
                        : 'منقضی شده'
                    }}
                    )</strong
                  >
                </v-col>
              </v-row>
              <v-col cols="12">
                <label for=""> درخواست کننده :</label>

                <strong @click="showMerchantInfoModal" class="mouse-over">
                  {{ merchantInfo.name }}
                </strong>
                
                <i @click="showMerchantInfoModal"
                  title="برای مشاهده اطلاعات بیشتر کلیک  کنید!"
                  style="font-size: small"
                  class="fa fa-exclamation-circle text-primary"
                ></i>
              </v-col>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="text-left"
              cols="12"
              v-if="
                selectedTrade &&
                selectedTrade.status != 'Accept' &&
                selectedTrade.responseStatus != 'Draft' &&
                selectedTrade.responseStatus != 'Sent'
              "
            >
              <v-btn v-if="selectedTrade &&  selectedTrade.bidExpirationTimeInDaysFromNow>0"
                class="mt-3"
                small
                color="primary"
                @click="acceptMerchantNotification()"
              >
                تمایل به شرکت دارم
              </v-btn>
            </v-col>
            <v-col
              class="text-left"
              cols="12"
              v-if="
                selectedTrade &&
                selectedTrade.status != 'Reject' &&
                selectedTrade.responseStatus != 'Draft' &&
                selectedTrade.responseStatus != 'Sent'
              "
            >
              <v-btn small color="error" @click="rejectMerchantNotification()" v-if="selectedTrade && selectedTrade.bidExpirationTimeInDaysFromNow>0">
                شرکت نمیکنم
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
        <!-- ----------------------------------stepper------------------------------------- -->
        <v-stepper
          v-model="stepper"
          vertical
          v-if="tradeItems && tradeItems.length"
        >
          <v-form
            ref="responseForm"
            v-model="responseFormsValid"
            v-for="(item, ind) in tradeItems"
            :key="ind"
          >
            <v-stepper-step :step="ind + 1" complete
              >مشاهده اسناد {{ tradeRequestDisplayName(selectedTrade.request) }}
            </v-stepper-step>
            <v-stepper-content :step="ind + 1" class="mr-n3 ml-n10">
              <v-sheet outlined class="my-3 pa-4">
                <!-- <v-card-text> -->
                <v-row>
                  <v-col
                    cols="12"
                    :md="item.documents && item.documents.length ? 6 : 0"
                    class="pa-4"
                    v-if="item.documents && item.documents.length"
                  >
                    <v-sheet class="px-3">
                      <v-row v-if="item.isDefault">
                        <v-col
                          cols="12"
                          v-for="(x, i) in item.documents"
                          :key="i"
                        >
                          <div v-if="x.isDefault">
                            <v-col cols="12">
                              <v-img
                                v-if="x.fileId && x.fileId.fileUrl"
                                :src="x.fileId.fileUrl"
                                max-height="350px"
                              />
                            </v-col>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-img
                            v-if="
                              item.documents[0] &&
                              item.documents[0].fileId &&
                              item.documents[0].fileId.fileUrl
                            "
                            :src="item.documents[0].fileId.fileUrl"
                            max-height="350px"
                          />
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-col>
                  <v-col
                    cols="12"
                    :md="item.documents && item.documents.length ? 6 : 12"
                    v-if="selectedTrade.request != 'ContractorRecognition'"
                  >
                    <v-col cols="12">
                      <label for="">
                        موضوع
                        {{ tradeRequestDisplayName(selectedTrade.request) }}
                        :</label
                      >
                      <strong>
                        {{ item.title }}
                      </strong>
                    </v-col>
                    <v-col cols="12">
                      <label for=""> تعداد :</label>
                      <strong>
                        {{ item.quantity | priceSplitter }}
                        {{ item.measurementUnitTitle }}
                      </strong>
                    </v-col>
                    <v-col cols="12">
                      <label for=""> زمان شروع تحویل دهی :</label>
                      <strong>
                        {{ jalaliDate(item.requireDateUtc) }}
                      </strong>
                    </v-col>
                    <v-col cols="12">
                      <label for="">مواد :</label>
                      <strong>
                        {{ item.rawMaterialName }}
                      </strong>
                    </v-col>
                    <v-col cols="12">
                      <label for=""> روش تحویل دهی :</label>
                      <strong>
                        {{
                          item.deliveryType == 'Periodical' ? 'ادواری' : 'یکجا'
                        }}
                      </strong>
                    </v-col>

                    <v-col cols="12">
                      <v-card>
                        <base-table
                          :headers="deliveryItemHeader"
                          :items="item.deliveryItems"
                          hide-default-footer
                        >
                          <template v-slot:[`item.deliveryDateUtc`]="{ item }">
                            {{ jalaliDate(item.deliveryDateUtc) }}
                          </template>
                        </base-table>
                      </v-card>
                    </v-col>
                  </v-col>
                  <v-col cols="12" md="6" v-else>
                    <v-col cols="12">
                      <label for=""> تشریح پروژه / طرح :</label>
                    </v-col>
                    <v-col cols="12">
                      <strong>
                        {{
                          selectedTrade.orderDescription &&
                          selectedTrade.orderDescription.length
                            ? selectedTrade.orderDescription
                            : 'وارد نشده'
                        }}
                      </strong>
                    </v-col>
                  </v-col>
                  <v-col cols="12" v-if="selectedTrade.category == 'Product' && selectedTrade.request !='DirectOrder'">
                    <strong
                      >مشخصات
                      {{ item.techInfos[0].productCategoryName }}</strong
                    >
                    <v-card width="98%" class="pa-5 ma-2">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          v-for="(property, index) in item.techInfos[0]
                            .tradeRequestItemPropertyValues"
                          :key="index"
                        >
                          <v-row>
                            <v-col cols="12" sm="4">
                              <label
                                >{{ property.categoryPropertyTitle }} :
                              </label></v-col
                            >

                            <v-col cols="12" sm="8">
                              <strong
                                v-if="
                                  property.propertyType == 'MultiSelectList'
                                "
                              >
                                <label
                                  v-for="(prop, index) in property.value.split(
                                    '|'
                                  )"
                                  :key="index"
                                >
                                  {{ prop.replaceAll('null', '') }}
                                  <label
                                    v-if="
                                      index <
                                        property.value.split('|').length - 1 &&
                                      prop
                                    "
                                  >
                                    -
                                  </label>
                                </label>
                              </strong>
                              <strong
                                v-else-if="property.propertyType == 'Logical'"
                              >
                                {{ property.value == true ? 'بله' : 'خیر' }}
                              </strong>
                              <strong v-else
                                >{{
                                  property.maxValue
                                    ? `از ${property.value} تا ${property.maxValue}`
                                    : property.value
                                }}
                                {{
                                  property.measurementUnitDisplayText
                                }}</strong
                              >
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="12" v-if="selectedTrade && selectedTrade.bidExpirationTimeInDaysFromNow>0">
                    <h6 class="mr-3">مشاهده اسناد :  </h6>
                    <v-sheet outlined class="ma-3">
                      <v-data-table
                        :items="item.documents"
                        :headers="documentTableHeader"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:[`item.documentTypeTitle`]="{ item }">
                          <v-btn
                            text
                            class="blue--text"
                            @click="
                              log(item);
                              selectedDoc = item;
                              documentModal = true;
                            "
                            >{{ item.documentTypeTitle }}</v-btn
                          >
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                          {{
                            item.description == ''
                              ? 'وارد نشده'
                              : item.description
                          }}
                        </template>
                        <template v-slot:[`item.downloadLink`]="{ item }">
                          <a
                            target="_blank"
                            :href="
                              item.fileId && item.fileId.fileUrl
                                ? item.fileId.fileUrl
                                : ''
                            "
                            >{{
                              item.fileId && item.fileId.fileUrl ? 'دانلود' : ''
                            }}
                          </a>
                        </template>
                        <template v-slot:[`item.reviewed`]="{ item }">
                          <v-checkbox
                            @click="documentValidationPerItem(ind)"
                            v-model="item.checkboxConfirmation"
                            :readonly="
                              selectedTrade.bidExpirationTimeInDaysFromNow ==
                                0 ||
                              (selectedTrade.responseStatus != 0 &&
                                selectedTrade.responseStatus != null &&
                                selectedTrade.responseStatus != 'Unknown')
                            "
                          >
                            <!-- 
                                                            selectedTrade.responseStatus != 'Draft' &&
                                selectedTrade.responseStatus != 'Sent'
                           -->
                          </v-checkbox>
                        </template>
                      </v-data-table>
                    </v-sheet>
                  </v-col>
                  <v-row class="px-5" v-if="selectedTrade && selectedTrade.bidExpirationTimeInDaysFromNow>0">
                    <v-col cols="8" sm="6" md="4" v-if="selectedTrade.request!='DirectOrder'">
                      شرایط شرکت در
                      {{ tradeRequestDisplayName(selectedTrade.request) }} را
                      قبول میکنم
                    </v-col>
                    <v-col cols="8" sm="6" md="4" v-else>
                      شرایط استعلام قیمت مستقیم را قبول می‌کنم
                    </v-col>
                    <v-col cols="4" sm="6" md="8">
                      <v-checkbox
                        :readonly="
                          selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                          (selectedTrade.responseStatus != 0 &&
                            selectedTrade.responseStatus != null &&
                            selectedTrade.responseStatus != 'Unknown' &&
                            selectedTrade.responseStatus != 'Draft' &&
                            selectedTrade.responseStatus != 'Sent')
                        "
                        class="mt-n3 mr-n3"
                        v-model="tradeTerms[ind]"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="8" sm="6" md="4">
                      <v-btn
                        class="mt-n4 mr-n4"
                        text
                        @click="openPublicTaksaanInfo"
                        >شرایط عمومی تکصان را قبول میکنم</v-btn
                      >
                    </v-col>
                    <v-col cols="4" sm="6" md="8">
                      <v-checkbox
                        :readonly="
                          selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                          (selectedTrade.responseStatus != 0 &&
                            selectedTrade.responseStatus != null &&
                            selectedTrade.responseStatus != 'Unknown' &&
                            selectedTrade.responseStatus != 'Draft' &&
                            selectedTrade.responseStatus != 'Sent')
                        "
                        class="mt-n3 mr-n3"
                        v-model="taksaanTerms[ind]"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <!-- <v-col cols="6" v-if="postData.allTermsConfirmedByMerchant"> -->
                  <v-row>
                    <v-row
                      class="px-7"
                      v-if="
                        taksaanTerms[ind] &&
                        tradeTerms[ind] &&
                        ((tradeItems[ind].documents.length > 0 &&
                          tradeItems[ind].docFlag) ||
                          tradeItems[ind].documents.length == 0)
                      "
                    >
                      <v-col cols="12">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          selectedTrade &&
                          selectedTrade.request != 'ContractorRecognition'
                        "
                      >
                        <h6 class="text-right float-right">
                          ثبت پیشنهاد قیمت و زمان :
                        </h6>
                      </v-col>
                      <v-col cols="12" v-else>
                        <h6 class="text-right float-right">ثبت پیشنهاد :</h6>
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="selectedTrade.request != 'ContractorRecognition'"
                      >
                        <label>
                          موضوع
                          {{ tradeRequestDisplayName(selectedTrade.request) }}
                          :</label
                        >
                        <strong>
                          {{ item.title }}
                        </strong>
                      </v-col>
                      <v-col
                        cols="6"
                        v-if="
                          selectedTrade &&
                          selectedTrade.request != 'ContractorRecognition'
                        "
                      >
                        <label> تعداد/مقدار درخواست شده :</label>
                        <strong>
                          {{ item.quantity | priceSplitter }}

                          ({{ item.measurementUnitTitle }})
                        </strong>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="
                          selectedTrade &&
                          selectedTrade.request != 'ContractorRecognition'
                        "
                      >
                        <!-- v-model="postItems[slotData.index].price.currency" -->
                        <v-select
                          class="mt-3 mb-n2"
                          dense
                          outlined
                          :items="currencyList"
                          item-text="title"
                          item-value="isoCode"
                          label="قیمت مبنا"
                          v-model="postItems[ind].price.currency"
                          readonly
                        >
                        </v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="
                          selectedTrade &&
                          selectedTrade.request != 'ContractorRecognition'
                        "
                      >
                        <!-- v-model="postItems[slotData.index].price.amount" -->
                        <v-text-field
                          class="mt-3 mb-n2"
                          dense
                          :readonly="
                            selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                            (selectedTrade.responseStatus != 0 &&
                              selectedTrade.responseStatus != null &&
                              selectedTrade.responseStatus != 'Unknown' &&
                              selectedTrade.responseStatus != 'Draft' &&
                              selectedTrade.responseStatus != 'Sent')
                          "
                          outlined
                          :rules="[
                            (v) => !!v || 'وارد کردن مقدار الزامی میباشد',
                          ]"
                          required
                          type="number"
                          :label="
                            currencyList &&
                            currencyList.find(
                              (x) => x.isoCode == postItems[ind].price.currency
                            ) &&
                            currencyList.find(
                              (x) => x.isoCode == postItems[ind].price.currency
                            ).title
                              ? ' قیمت واحد ( ' +
                                currencyList.find(
                                  (x) =>
                                    x.isoCode == postItems[ind].price.currency
                                ).title +
                                ')'
                              : ''
                          "
                          v-model="postItems[ind].price.amount"
                          placeholder="صفحه کلید به انگلیسی باشد"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="
                          selectedTrade &&
                          selectedTrade.request != 'ContractorRecognition'
                        "
                      >
                        <!-- v-model="postItems[slotData.index].totalAmount" -->
                        <v-text-field
                          class="mt-3 mb-n2"
                          dense
                          outlined
                          :readonly="
                            selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                            (selectedTrade.responseStatus != 0 &&
                              selectedTrade.responseStatus != null &&
                              selectedTrade.responseStatus != 'Unknown' &&
                              selectedTrade.responseStatus != 'Draft' &&
                              selectedTrade.responseStatus != 'Sent')
                          "
                          placeholder="صفحه کلید به انگلیسی باشد"
                          required
                          :label="
                            currencyList &&
                            currencyList.find(
                              (x) => x.isoCode == postItems[ind].price.currency
                            ) &&
                            currencyList.find(
                              (x) => x.isoCode == postItems[ind].price.currency
                            ).title
                              ? 'تعداد قابل تامین( ' +
                                item.measurementUnitTitle +
                                ')'
                              : ''
                          "
                          :rules="[
                            (v) => {
                              if (!v) {
                                return 'وارد کردن مقدار الزامی میباشد';
                              } else if (v && v > item.quantity)
                                return 'تعداد قابل تامین باید کمتر از تعداد سفارش باشد ';
                            },
                          ]"
                          type="number"
                          v-model="postItems[ind].totalAmount"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          selectedTrade &&
                          selectedTrade.request != 'ContractorRecognition'
                        "
                      >
                        <label> قیمت کل : </label>
                        <strong>
                          {{
                            (postItems[ind].totalAmount *
                              postItems[ind].price.amount)
                              | priceSplitter
                          }}
                          ({{
                            (
                              postItems[ind].totalAmount *
                              postItems[ind].price.amount
                            ).num2persian()
                          }})
                          {{
                            currencyList.find(
                              (x) => x.isoCode == postItems[ind].price.currency
                            ) &&
                            currencyList.find(
                              (x) => x.isoCode == postItems[ind].price.currency
                            ).title
                              ? currencyList.find(
                                  (x) =>
                                    x.isoCode == postItems[ind].price.currency
                                ).title
                              : ''
                          }}
                        </strong>
                      </v-col>
                    </v-row>

                    <v-col
                      class="px-5"
                      cols="12"
                      v-if="
                        selectedTrade &&
                        selectedTrade.request != 'ContractorRecognition' &&
                        taksaanTerms[ind] &&
                        tradeTerms[ind] &&
                        ((tradeItems[ind].documents.length > 0 &&
                          tradeItems[ind].docFlag) ||
                          tradeItems[ind].documents.length == 0)
                      "
                    >
                      <v-row class="pa-4"
                        >راهنما
                        <HelperComponent
                          helperId="how-to-fill-order-price-in-trade-response"
                          class="float-left"
                        />
                      </v-row>
                      <v-textarea
                        :readonly="
                          selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                          (selectedTrade.responseStatus != 0 &&
                            selectedTrade.responseStatus != null &&
                            selectedTrade.responseStatus != 'Unknown' &&
                            selectedTrade.responseStatus != 'Draft' &&
                            selectedTrade.responseStatus != 'Sent')
                        "
                        :required="postItems[ind].totalAmount < item.quantity"
                        :rules="[
                          (v) => {
                            if (
                              (!v &&
                                postItems[ind].totalAmount < item.quantity) ||
                              v.length > 2048
                            ) {
                              if (
                                !v &&
                                postItems[ind].totalAmount < item.quantity
                              ) {
                                return 'دلیل تعداد کمتر از مقدار درخواستی را توضیح دهید';
                              }
                              if (v.length > 2048) {
                                return 'تعداد کاراکتر ها باید کمتر از 2048 عدد باشد';
                              }
                            } else return true;
                          },
                        ]"
                        dense
                        rows="4"
                        outlined
                        v-model="postItems[ind].description"
                        label="توضیحات شما"
                        class="mt-3"
                      ></v-textarea>
                    </v-col>

                    <v-col
                      class="px-5"
                      cols="12"
                      v-if="
                        selectedTrade &&
                        selectedTrade.request == 'ContractorRecognition' &&
                        taksaanTerms[ind] &&
                        tradeTerms[ind] &&
                        ((tradeItems[ind].documents.length > 0 &&
                          tradeItems[ind].docFlag) ||
                          tradeItems[ind].documents.length == 0)
                      "
                    >
                      <v-row class="pa-4"
                        >راهنما
                        <HelperComponent
                          helperId="how-to-fill-order-price-in-trade-response"
                          class="float-left"
                        />
                      </v-row>
                      <v-textarea
                        :readonly="
                          selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                          (selectedTrade.responseStatus != 0 &&
                            selectedTrade.responseStatus != null &&
                            selectedTrade.responseStatus != 'Unknown' &&
                            selectedTrade.responseStatus != 'Draft' &&
                            selectedTrade.responseStatus != 'Sent')
                        "
                        dense
                        rows="4"
                        outlined
                        v-model="postItems[ind].description"
                        label="توضیحات شما"
                        class="mt-3"
                      ></v-textarea>
                    </v-col>

                    <v-col
                      cols="12"
                      v-if="
                        taksaanTerms[ind] &&
                        tradeTerms[ind] &&
                        ((tradeItems[ind].documents.length > 0 &&
                          tradeItems[ind].docFlag) ||
                          tradeItems[ind].documents.length == 0)
                      "
                    >
                      <v-col cols="12" md="6">
                        <label for="">اسناد پیوست پیشنهاد:</label>
                        <span
                          >فقط فایل هایی از نوع
                          jpg,.jpeg,.png,.gif,.webp,.bmp,.svg,.pdf قابل قبول
                          میباشد.
                        </span>
                        <v-select
                          v-if="
                            selectedTrade &&
                            selectedTrade.request != 'ContractorRecognition'
                          "
                          item-text="documentTypeTitle"
                          :readonly="
                            selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                            (selectedTrade.responseStatus != 0 &&
                              selectedTrade.responseStatus != null &&
                              selectedTrade.responseStatus != 'Unknown' &&
                              selectedTrade.responseStatus != 'Draft' &&
                              selectedTrade.responseStatus != 'Sent')
                          "
                          item-value="id"
                          persistent-hint
                          clearable
                          dense
                          outlined
                          label="فایل اطلاعات پیوست*"
                          :items="attachInformationFileList"
                          v-model="document.documentTypeId"
                        >
                          <template v-slot:item="{ item }">
                            <label>
                              {{ item.documentTypeTitle }}
                              {{ item.isOptional ? ' (اجباری) ' : '(اختیاری)' }}
                            </label>
                          </template>
                        </v-select>
                        <v-select
                          v-else
                          item-text="documentTypeTitle"
                          :readonly="
                            selectedTrade.bidExpirationTimeInDaysFromNow == 0 ||
                            (selectedTrade.responseStatus != 0 &&
                              selectedTrade.responseStatus != null &&
                              selectedTrade.responseStatus != 'Unknown' &&
                              selectedTrade.responseStatus != 'Draft' &&
                              selectedTrade.responseStatus != 'Sent')
                          "
                          item-value="id"
                          persistent-hint
                          clearable
                          dense
                          outlined
                          label="فایل اطلاعات پیوست*"
                          :items="attachInformationFileList"
                          v-model="document.documentTypeId"
                        >
                          <template v-slot:item="{ item }">
                            <label>
                              {{ item.documentTypeTitle }}
                              {{ item.isOptional ? '(اختیاری) ' : '(اجباری)' }}
                            </label>
                          </template>
                        </v-select>
                        <span
                          class="red--text mt-n3"
                          v-if="
                            validationErr &&
                            !validationErr.validate &&
                            validationErr.errorMessage
                          "
                        >
                          {{ validationErr.errorMessage }}
                        </span>
                        <v-card
                          max-width="700"
                          class="my-3"
                          v-if="
                            document.documentTypeId &&
                            document.documentTypeId.length
                          "
                        >
                          <v-row>
                            <v-card-text>
                              <v-col cols="12">
                                <v-text-field
                                  label="توضیحات فایل"
                                  v-model="document.description"
                                  dense
                                  :required="
                                    document.description &&
                                    document.description.length > 0
                                  "
                                  :rules="[
                                    (v) => {
                                      if (
                                        v &&
                                        (v.length > 2048 || v.length < 5)
                                      ) {
                                        return 'تعداد کاراکتر ها باید بین 5 تا 2048 عدد باشد';
                                      } else return true;
                                    },
                                  ]"
                                  outlined
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  style="direction: ltr"
                                  label="انتخاب فایل"
                                  outlined
                                  show-size
                                  ref="file"
                                  :rules="[
                                    (v) =>
                                      !!v || 'وارد کردن مقدار الزامی میباشد',
                                  ]"
                                  required
                                  :clearable="false"
                                  dense
                                  @change="uploadFile($event)"
                                  >انتخاب فایل</v-file-input
                                >
                              </v-col>
                              <v-col cols="12">
                                <v-spacer></v-spacer>
                                <v-btn
                                  class="float-left"
                                  color="primary"
                                  @click="addFile(ind)"
                                  >افزودن
                                </v-btn>
                              </v-col>
                            </v-card-text>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="12">
                        <TradeDocumentFileList
                          v-if="attachedItems[ind] && attachedItems[ind].length"
                          :items="attachedItems[ind]"
                          @removeAttachedItem="removeAttachedItem"
                        />
                      </v-col>
                    </v-col>
                  </v-row>
                </v-row>
                <!-- 
                  $refs['responseForm'][index].validate()
                    ? nextStep()
                    : validationError()
                 -->
                <!-- </v-card-text> -->
              </v-sheet>
              <v-btn
                color="primary"
                class="mx-2"
                @click="
                  $refs['responseForm'][index].validate() && documentValidation
                    ? nextStep()
                    : validationError()
                "
                v-if="stepper < selectedTrade.items.length"
              >
                ردیف بعدی تقاضا
              </v-btn>
              <!-- <v-btn color="primary" class="mx-2" @click="stepper += 1; " v-else> ثبت </v-btn> -->

              <v-btn
                color="error"
                class="mx-2"
                @click="
                  stepper -= 1;
                  index -= 1;
                "
                v-if="stepper > 1"
              >
                ردیف قبلی تقاضا
              </v-btn>
            </v-stepper-content>
          </v-form>
          <v-dialog
            v-if="documentModal && selectedDoc != null"
            v-model="documentModal"
            width="700px"
          >
            <v-card>
              <v-card-title>{{ selectedDoc.documentTypeTitle }} </v-card-title>
              <v-img
                :src="
                  selectedDoc.fileId && selectedDoc.fileId.fileUrl
                    ? selectedDoc.fileId.fileUrl
                    : ''
                "
              >
              </v-img>
              <v-card-text class="mt-5">
                <v-row>
                  <v-col cols="12">
                    <label for="">توضیحات:</label>
                    <strong>
                      {{ selectedDoc.description }}
                    </strong>
                  </v-col>
                  <v-col cols="12">
                    <a
                      target="_blank"
                      :href="
                        selectedDoc.fileId && selectedDoc.fileId.fileUrl
                          ? selectedDoc.fileId.fileUrl
                          : ''
                      "
                      >{{
                        selectedDoc.fileId && selectedDoc.fileId.fileUrl
                          ? 'دانلود فایل'
                          : ''
                      }}
                    </a>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn color="error" @click="documentHasViewed">بستن </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-if="taksaanModal" v-model="taksaanModal" width="900px">
            <v-card>
              <v-card-title>{{ title }}</v-card-title>
              <v-divider />
              <v-card-text v-html="body"> </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="error" @click="taksaanModal = false">
                  بستن
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-if="merchantInfoModal"
            v-model="merchantInfoModal"
            width="800px"
          >
            <v-card class="mx-auto">
              <v-card-title color="secondry">اطلاعات سفارش دهنده</v-card-title>
              <v-card-text>
                <v-row class="pa-5">
                  <v-col cols="6" md="4">
                    <label for="">نام کسب و کار :</label>
                    <strong>
                      {{ merchantInfo.name }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4">
                    <label for="">نوع کسب و کار :</label>
                    <strong>
                      {{
                        merchantInfo.companyTypeGroupItemDto
                          .companyTypeGroupTitle
                      }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4">
                    <label for="">نام مدیرعامل :</label>
                    <strong>
                      {{ merchantInfo.managerPerson.firstName }}
                      {{ merchantInfo.managerPerson.lastName }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">نوع شرکت :</label>
                    <strong>
                      {{ merchantInfo.company.companyTypeName }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-else>
                    <label for="">نوع ثبت :</label>
                    <strong>
                      {{ merchantInfo.company.companyTypeName }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">عنوان برند :</label>
                    <strong>
                      {{ merchantInfo.company.brandName }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">شناسه ملی :</label>
                    <strong>
                      {{ merchantInfo.company.nationalId }}
                    </strong>
                  </v-col>
                  <v-col
                    cols="6"
                    md="4"
                    v-if="this.merchantInfo.companyTypeGroupId == 1"
                  >
                    <label for="">شناسه ثبت :</label>
                    <strong>
                      {{ merchantInfo.company.registrarNumber }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-if="this.merchantInfo.address">
                    <label for="">استان :</label>
                    <strong>
                      {{ merchantInfo.address.stateName }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-if="this.merchantInfo.address">
                    <label for="">شهر :</label>
                    <strong>
                      {{ merchantInfo.address.cityName }}
                    </strong>
                  </v-col>
                  <v-col cols="6" md="4" v-if="this.merchantInfo.address">
                    <label for="">شهرک صنعتی :</label>
                    <strong>
                      {{
                        !!merchantInfo.address.industrialParkName
                          ? merchantInfo.address.industrialParkName
                          : 'وارد نشده'
                      }}
                    </strong>
                  </v-col>
                  <v-col cols="12" v-if="this.merchantInfo.address">
                    <label for="">اطلاعات تکمیلی آدرس :</label>
                    <strong>
                      {{
                        !!merchantInfo.address.addressLane
                          ? merchantInfo.address.addressLane
                          : 'وارد نشده'
                      }}
                    </strong>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="merchantInfoModal = false"
                  >بستن</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-stepper>
        <!-- --------------------------------end of stepper------------------------------- -->
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          @click="
            $router.push({
              path: `/trade-response`,
            });
            $store.commit('setTradeResponseHasResponse', false);
          "
        >
          بستن
        </v-btn>
        <v-btn
          color="success"
          @click="viewReport()"
          v-if="
            (selectedTrade && selectedTrade.responseStatus == 'Draft') ||
            sendFlag
          "
        >
          بررسی جهت ارسال
        </v-btn>
        <v-btn
          color="primary"
          @click="saveResponse()"
          v-if="
            !$store.getters.tradeResponseIsEdit &&
            selectedTrade &&
            (selectedTrade.responseStatus == null ||
              selectedTrade.responseStatus == 0)
          "
          :disabled="validationCheckMarks || submitFlag"
        >
          ذخیره
        </v-btn>
        <v-btn
          color="primary"
          @click="saveResponse()"
          v-if="
            $store.getters.tradeResponseIsEdit &&
            selectedTrade &&
            (selectedTrade.responseStatus == 'Draft' ||
              selectedTrade.responseStatus == 'Sent')
          "
        >
          ویرایش</v-btn
        >
      </v-card-actions>
    </v-card>
    <div v-else>
      <TradeResponseReport
        @reportFlag="
          reportFlag = false;
          reportData = null;
        "
        @getData="getData"
        :propData="reportData"
        :selectedTrade="selectedTrade"
      >
      </TradeResponseReport>
    </div>
    <v-dialog
      v-if="deleteDialogConfirm"
      v-model="deleteDialogConfirm"
      max-width="400px"
    >
      <v-card>
        <v-toolbar color="primary" dark dense>توجه</v-toolbar>
        <v-card-text class="mt-3">
          <strong>
            با برداشتن چک مارک، پاسخ مربوطه حذف میشود. آیا از حذف مطمئن هستید؟
          </strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small color="error" @click="remainItem"> خیر </v-btn>
          <v-btn small color="success" @click="deleteItem">بله </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TradeResponseReport from './TradeResponseReport.vue';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const currenciesRepository = () => RepoFactory.get('currencies');
const tradeResponseRepository = () => RepoFactory.get('tradeResponse');
const tradeRequestRepository = () => RepoFactory.get('tradeRequests');
const filesRepository = () => RepoFactory.get('files');
const merchantRepository = () => RepoFactory.get('merchant');
import TradeDocumentFileList from './TradeDocumentFileList.vue';
import { uuid } from 'vue-uuid';
import { mapGetters } from 'vuex';
const pagesRepository = () => RepoFactory.get('pages');
// import Num2persian from 'num2persian';

const initialData = {
  tradeRequestId: 0,
  description: null,
  documents: null,
  items: null,
  // allTermsConfirmedByMerchant: true,
};
export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],

  components: {
    TradeDocumentFileList,
    TradeResponseReport,
  },
  data() {
    return {
      deleteDialogConfirm: false,
      type: null,
      itemIndex: null,
      taksaanWatcher: [],
      tradeWatcher: [],
      submitFlag: false,
      reportData: null,
      reportFlag: false,
      responseId: null,
      sendFlag: false,
      // validationCheckMarks:false,
      merchantInfoModal: false,
      taksaanModal: false,
      title: '',
      body: '',
      selectedDoc: null,
      taksaanTerms: [],
      tradeTerms: [],
      merchantInfo: [],
      index: 0,
      documentModal: false,
      stepper: 1,
      responseFormsValid: true,
      currencyList: [],
      checkboxConfirmation: [],
      singleItem: {
        totalAmount: null,
        description: '',
        documents: [],
        price: {
          currency: 'IRR',
          amount: null,
        },
        tradeRequestItemId: 0,
      },
      tradeItems: [],
      postItems: [],
      postData: { ...initialData },
      validationErr: {
        validate: true,
        errorMessage: '',
      },
      document: {
        documentTypeId: null,
        fileId: '',
        description: '',
        expirationDateUtc: '',
      },
      singleAttachedItem: {},
      attachedItems: [],
      attachInformationFileList: [],
      attachInformationFileSelected: '',
      expanded: [],
      tradeRequestTypeList: [],
      tradeCategoriesList: [],
      indexExpanded: [],
      selectedTrade: null,
      selectedItem: null,
      deliveryItemHeader: [
        {
          text: 'تعداد',
          value: 'amount',
        },
        {
          text: 'تاریخ',
          value: 'deliveryDateUtc',
        },
      ],
      documentTableHeader: [
        {
          text: 'نوع سند',
          value: 'documentTypeTitle',
        },
        {
          text: 'توضیحات',
          value: 'description',
        },
        {
          text: 'دانلود فایل',
          value: 'downloadLink',
        },
        {
          text: 'وضعیت مشاهده',
          value: 'reviewed',
        },
      ],
      tradeResponseInfoItems: [],
      tradeResponseInfoHeaders: [
        {
          text: 'نام',
          value: 'title',
        },
        {
          text: 'تعداد سفارش',
          value: 'quantity',
        },
        {
          text: 'واحد',
          value: 'measurementUnitTitle',
        },
        {
          text: 'مدارک و مستندات',
          value: 'showDocuments',
        },
        {
          text: 'تعداد قابل تامین',
          value: 'suppliableAmount',
        },
        {
          text: 'قیمت بر حسب',
          value: 'currency',
        },
        {
          text: 'مبلغ واحد',
          value: 'fee',
        },
      ],
    };
  },
  created() {
    if (this.merchantId && this.merchantId.length) {
     this.getData();
    }
  },
  watch: {
    selectedTrade(after, befor) {
      if (after.merchantId.length > 1) {
        this.getMerchantInfo(after.merchantId);
      }
    },
    merchantId(after, before) {
      if (after.length && before == null) {
        this.getData();
      }
    },
    tradeTerms: {
      deep: true,
      handler: function (after) {
        this.tradeWatcher.push([...after]);
        if (this.tradeWatcher.length == 3) {
          this.tradeWatcher.shift();
          if (
            this.$store.getters.tradeResponseIsEdit &&
            this.tradeWatcher[1].filter(Boolean).length <
              this.tradeWatcher[0].filter(Boolean).length
          ) {
            this.tradeWatcher[1].forEach((x, i) => {
              if (
                this.tradeWatcher[1][i] != this.tradeWatcher[0][i] &&
                this.postItems[i].id &&
                this.postItems[i].totalAmount
              ) {
                this.confirmaionToDeleteItem(
                  this.$store.getters.tradeResponseSelectedForEdit.items[i],
                  'tradeTerms',
                  i
                );
              }
            });
          }
        }
      },
    },
    taksaanTerms: {
      deep: true,
      handler: function (after) {
        this.taksaanWatcher.push([...after]);
        if (this.taksaanWatcher.length == 3) {
          this.taksaanWatcher.shift();
          if (
            this.$store.getters.tradeResponseIsEdit &&
            this.taksaanWatcher[1].filter(Boolean).length <
              this.taksaanWatcher[0].filter(Boolean).length
          ) {
            this.taksaanWatcher[1].forEach((x, i) => {
              if (
                this.taksaanWatcher[1][i] != this.taksaanWatcher[0][i] &&
                this.postItems[i].id &&
                this.postItems[i].totalAmount
              ) {
                this.confirmaionToDeleteItem(
                  this.$store.getters.tradeResponseSelectedForEdit.items[i],
                  'taksaanTerms',
                  i
                );
              }
            });
          }
        }
      },
    },
  },
  computed: {
    documentValidation() {
      if (this.tradeTerms[this.index] && this.taksaanTerms[this.index]) {
        let ids = [];
        //
        console.log(this.postItems[this.index], this.postItems, this.index);

        this.postItems[this.index].documents.forEach((x) => {
          ids.push(x.documentTypeId);
        });
        //
        if (this.validationErr.validate) {
          let flag = true;
          this.attachInformationFileList.forEach((x) => {
            if (this.validationErr.validate && (x.required || !x.isOptional)) {
              if (!ids.includes(x.id)) {
                flag = false;
                this.validationErr = {
                  validate: false,
                  errorMessage: 'برای تمام آیتم های اجباری مدارک آپلود کنید. ',
                };
                return false;
              }
            }
          });
          if (flag) {
            return true;
          }
        } else if (!this.validationErr.validate) {
          this.$dialog.error({
            text: 'اطلاعات مربوط به تمام آیتم های اجباری در فایل اطلاعات پیوست را بارگزاری کنید',
            title: 'خطا',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                caolor: 'red',
              },
            ],
          });
          return false;
        }
      } else {
        return true;
      }
    },
    validationCheckMarks() {
      let itemFlag = true;

      this.tradeItems.forEach((item, ind) => {
        if (
          this.taksaanTerms[ind] &&
          this.tradeTerms[ind] &&
          ((this.tradeItems[ind].documents.length > 0 &&
            this.tradeItems[ind].docFlag) ||
            this.tradeItems[ind].documents.length == 0)
        ) {
          itemFlag = false;
        }
      });

      if (!itemFlag) return false;
      else return true;
    },
    id() {
      return this.$route.params.id;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    fileBaseUrl() {
      return this.$store.getters.fileBaseUrl;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    accountingBaseUrl() {
      return this.$store.getters.accountingServiceBaseUrl;
    },
    ...mapGetters(['uniquePageApprovingTaksaanRuleOnTrade', 'contentBaseUrl']),
  },
  methods: {
    confirmaionToDeleteItem(item, type, index) {
      this.selectedForDelete = item;
      this.deleteDialogConfirm = true;
      this.type = type;
      this.itemIndex = index;
    },
    deleteItem() {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .deleteResponseItem(
          this.$store.getters.tradeResponseSelectedForEdit.id,
          { tradeResponseItemId: this.selectedForDelete.id },
          this.tradeBaseUrl,
          { MerchantId: this.merchantId }
        )
        .then((res) => {
          this.$dialog.message.success(
            ' پاسخ شما به قلم مورد نظر با موفقیت حذف شد. ',
            {
              position: 'top-left',
            }
          );
          this.selectedForDelete = null;
          this.deleteDialogConfirm = false;
          this.type = null;
          this.itemIndex = null;
          this.clearStore();
          this.$router.push('/trade-response');
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    remainItem() {
      if (this.type == 'tradeTerms') {
        this.tradeTerms[this.itemIndex] = true;
        this.selectedForDelete = null;
        this.deleteDialogConfirm = false;
        this.type = null;
        this.itemIndex = null;
      } else if (this.type == 'taksaanTerms') {
        this.taksaanTerms[this.itemIndex] = true;
        this.selectedForDelete = null;
        this.deleteDialogConfirm = false;
        this.type = null;
        this.itemIndex = null;
      }
    },
    clearStore() {
      this.$store.commit('setTradeResponseMerchantNotificationId', null);
      this.$store.commit('setTradeResponseHasResponse', false);
      this.$store.commit('setTradeResponseSelectedForEdit', null);
      this.$store.commit('setTradeResponseIsEdit', false);
      this.$store.commit('setTradeResponseShowForm', false);
      this.$store.commit('setTradeResponseId', null);
    },
    nextStep() {
      this.stepper += 1;
      this.index += 1;
    },

    documentValidationPerItem(index) {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .documnetsReviewedMerchantNotification(
          this.$store.getters.tradeResponseMerchantNotificationId,
          {
            tradeRequestId: this.selectedTrade.id,
            tradeRequestItemId: this.tradeItems[this.index].id,
          },
          this.tradeBaseUrl,
          { MerchantId: this.merchantId }
        )
        .then((res) => {
          this.tradeItems[index].docFlag = false;
          let flag = true;
          this.tradeItems[index].documents.forEach((x, i) => {
            if (!x.checkboxConfirmation) flag = false;
          });
          if (flag) this.tradeItems[index].docFlag = true;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    openPublicTaksaanInfo() {
      let params = {
        uniquePageName: this.uniquePageApprovingTaksaanRuleOnTrade,
      };
      const loader = this.$loading.show();
      pagesRepository()
        .getUniquePage(this.contentBaseUrl, {}, params)
        .then(({ data }) => {
          this.title = data.title;
          this.body = data.body;
          this.taksaanModal = true;
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
        //kazemi Approve Doc Review if DirectOrder
    },
    fillPostItem(index) {
      this.postItems[index].totalAmount = this.singleItem.totalAmount;
      this.postItems[index].description = this.singleItem.description;
      this.postItems[index].documents = this.singleItem.documents;
      this.postItems[index].price.currency = this.singleItem.price.currency;
      this.postItems[index].price.amount = this.singleItem.price.amount;
      this.singleItem = {
        totalAmount: null,
        description: '',
        documents: [],
        price: {
          currency: 'IRR',
          amount: null,
        },
        tradeRequestItemId: 0,
      };
    },
    log(item) {
      console.log(item);
    },
    documentHasViewed() {
      this.tradeItems[this.index].documents[
        this.selectedDoc.index
      ].checkboxConfirmation = true;
      this.selectedDoc = null;
      this.documentModal = false;
      this.documentValidationPerItem(this.index);
    },

    getData() {
      let app = this;
      const loader = this.$loading.show();
      tradeResponseRepository()
        .getTradeRequsetByIdForResponse(this.id, this.tradeBaseUrl, {
          MerchantId: this.merchantId,
        })
        .then((res) => {
          loader.hide();
          app.attachedItems = [];
          app.postItems = [];
          app.tradeResponseInfoItems = [];
          app.tradeItems = [];
          app.selectedTrade = res.data;
          app.selectedTrade.items.forEach((item, ind) => {
            let defaultFlag = false;
            item.documents.forEach((x, i) => {
              x.index = i;
              if (this.$store.getters.tradeResponseIsEdit)
                x.checkboxConfirmation = true;
              else x.checkboxConfirmation = false;
              if (x.isDefault) {
                defaultFlag = true;
              }
            });
            if (defaultFlag) item.isDefault = true;
            else item.isDefault = false;
            if (this.$store.getters.tradeResponseIsEdit) {
              item = { index: ind, docFlag: true, ...item };
            } else {
              item = { index: ind, docFlag: false, ...item };
            }
            app.singleItem.tradeRequestItemId = item.id;
            app.postItems.push({
              totalAmount: null,
              description: '',
              documents: [],
              price: {
                currency: 'IRR',
                amount: null,
              },
              tradeRequestItemId: item.id,
            });
            app.tradeItems.push(item);
            app.tradeResponseInfoItems.push(item);
            app.attachedItems.push([]);
            if (this.$store.getters.tradeResponseIsEdit) {
              let flagg = false;
              //
              this.$store.getters.tradeResponseSelectedForEdit.items.forEach(
                (xx, ii) => {
                  if (xx.tradeRequestItemId == item.id) {
                    flagg = true;
                    app.taksaanTerms.push(true);
                    app.tradeTerms.push(true);
                    app.postItems[ind].totalAmount = xx.totalAmount;
                    app.postItems[ind].id = xx.id;
                    app.postItems[ind].description = xx.description;
                    app.postItems[ind].price.currency = xx.price.currency;
                    app.postItems[ind].price.amount = xx.price.amount;

                    let editSingleAttachedItem;
                    xx.documents.forEach((dx, di) => {
                      app.postItems[ind].documents.push({
                        documentTypeId: dx.documentTypeId,
                        fileId: dx.fileId.fileId,
                        description: dx.description,
                        expirationDateUtc: dx.expirationDateUtc,
                        categoryType: dx.categoryType,
                        id: dx.id,
                      });

                      editSingleAttachedItem = {
                        description: dx.description,
                        documentTypeTitle: dx.documentTypeTitle,
                        file: dx.fileId,
                        status: dx.status,
                        id: dx.id,
                      };
                      this.attachedItems[ind].push(editSingleAttachedItem);
                    });
                  }
                }
              );
              if (!flagg) {
                app.taksaanTerms.push(false);
                app.tradeTerms.push(false);
              }
            } else {
              app.taksaanTerms.push(false);
              app.tradeTerms.push(false);
            }
          });
          // console.log("app.tradeItems")
          // console.log(app.tradeItems)
          app.tradeWatcher.push([...app.tradeTerms]);
          app.taksaanWatcher.push([...app.taksaanTerms]);
          
          app.getCurrencies();
          app.tradeCategories();
          app.tradeRequestType();
          
          app.getAttachmentFileList();
          // app.getMerchantInfo(res.data.merchantId)
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    async getMerchantInfo(id) {
      const loader = this.$loading.show();
    
      await merchantRepository()
        .getMerchantInformationById(id, this.merchantBaseUrl)
        .then((res) => {
          this.merchantInfo = res.data;
          //this.merchantInfoModal = true;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    showMerchantInfoModal() {
      this.merchantInfoModal = true;
    },
    saveResponse() {
      let validation = true;
      this.postItems.forEach((x, i) => {
        validation = validation * this.$refs['responseForm'][i].validate();
      });
      if (validation && this.documentValidation) {
        this.postItems.forEach((item) => {
          item.documents.forEach((doc) => {
            if (doc.fileUniqueId) {
              delete doc.fileUniqueId;
            }
          });
        });
        let temp = this.postItems;
        let errFlag = false;
        let ind = [];
        temp.forEach((item, i) => {
          if (item.totalAmount == null && item.price.amount == null) {
            if (this.selectedTrade.request != 'ContractorRecognition') {
              ind.push(i);
            } else if (
              this.selectedTrade.request == 'ContractorRecognition' &&
              ((item.documents.length && item.description == '') ||
                (item.documents.length == 0 && item.description != ''))
            ) {
              item.totalAmount = 1;
              item.price.amount = 1;
              item.allTermsConfirmedByMerchant = true;
            } else if (
              this.selectedTrade.request == 'ContractorRecognition' &&
              !(item.documents.length || item.description != '')
            ) {
              this.$dialog.error({
                text: 'برای ارسال پاسخ حداقل یک مشخصه سند یا توضیحات ثبت کنید.',
                title: 'خطا',
                persistent: true,
                actions: [
                  {
                    text: 'بستن',
                    color: 'red',
                  },
                ],
              });
              errFlag = true;
            }
          } else {
            item.allTermsConfirmedByMerchant = true;
          }
        });
        ind.forEach((i) => {
          temp.splice(i, 1);
        });
        if (temp.length > 0 && !errFlag) {
          if (!this.$store.getters.tradeResponseIsEdit) {
            this.postData.items = temp;
            this.postData.tradeRequestId = this.selectedTrade.id;

            const loader = this.$loading.show();
            tradeResponseRepository()
              .saveResponse(this.postData, this.tradeBaseUrl, {
                MerchantId: this.merchantId,
              })
              .then((res) => {
                this.responseId = res.data.id;
                this.$dialog.message.success(
                  ' پاسخ شما به سفارش مورد نظر با موفقیت ثبت شد. ',
                  {
                    position: 'top-left',
                  }
                );
                let tempp = this.$store.getters.tradeResponseProp;
                // temp = this.$store.getters.tradeResponseProp

                this.submitFlag = true;
                tempp.tradeResponseId = res.data.id;

                this.$store.commit('setTradeResponseProp', tempp);
                this.sendFlag = true;
                loader.hide();
              })
              .catch((error) => {
                Helper.handleErrors(error, this);
                loader.hide();
              })
              .finally(() => loader.hide());
          } else {
            this.postData.items = temp;
            this.postData.tradeRequestId = this.selectedTrade.id;

            const loader = this.$loading.show();
            tradeResponseRepository()
              .editResponse(
                this.$store.getters.tradeResponseId,
                this.postData,
                this.tradeBaseUrl,
                {
                  MerchantId: this.merchantId,
                }
              )
              .then((res) => {
                this.$dialog.message.success(
                  ' پاسخ شما به سفارش مورد نظر با موفقیت ویرایش شد. ',
                  {
                    position: 'top-left',
                  }
                );
                this.submitFlag = true;

                if (
                  this.selectedTrade.responseStatus == null ||
                  this.selectedTrade.responseStatus == 0
                ) {
                  this.selectedTrade.responseStatus == 'Draft';
                  this.sendFlag = true;
                } else if (this.selectedTrade.responseStatus == 'Draft') {
                  this.sendFlag = true;
                } else {
                  this.$store.commit('setTradeResponseId', null);
                  this.$store.commit('setTradeResponseSelectedForEdit', null);
                  this.$store.commit('setTradeResponseIsEdit', false);
                  this.$store.commit('setTradeResponseShowForm', false);
                  this.$router.push({
                    path: `/trade-response`,
                  });
                }
                loader.hide();
              })
              .catch((error) => {
                Helper.handleErrors(error, this);
                loader.hide();
              })
              .finally(() => loader.hide());
          }
        } else {
          this.$dialog.error({
            text: 'پاسخ داده شده نامعتبر یا ناقص است ',
            title: 'خطا',
            persistent: true,
            actions: [
              {
                text: 'بستن',
                color: 'red',
              },
            ],
          });
          return;
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن موارد ستاره دار الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },

    tradeCategories() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('CategoryTypeItems', this.tradeBaseUrl)
        .then((res) => {
          this.tradeCategoriesList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    tradeRequestType() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('TradeRequestType', this.tradeBaseUrl)
        .then((res) => {
          //return;
          this.tradeRequestTypeList = res.data;

          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        // console.log("tradeRequestTypeList")
        // console.log(this.tradeRequestTypeList)
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
       // console.log(result)
        if (result) return result.displayName;
      }
    },
    getCurrencies() {
      const loader = this.$loading.show();
      currenciesRepository()
        .getCurrencies(this.accountingBaseUrl)
        .then((res) => {
          this.currencyList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => {
          loader.hide();
        });
    },
    getAttachmentFileList() {
      // if(this.selectedTrade.request != 'ContractorRecognition'){
      // const loader = this.$loading.show();
      // let params = {
      //   requestType: this.selectedTrade.request,
      //   categories: this.selectedTrade.category,
      //   flow: 'TradeResponse',
      // };
      // tradeRequestRepository()
      //   .getDocumentType(this.tradeBaseUrl, {}, params)
      //   .then((res) => {
      //     if(res.data && res.data.length){
      //       this.attachInformationFileList = res.data;
      //     }
      //     else{
      //       this.attachInformationFileList =[]
      //     }
      //     loader.hide();
      //   })
      //   .catch((err) => {
      //     Helper.handleErrors(err, this);
      //     loader.hide();
      //   })
      //   .finally(() => loader.hide());
      //   }
      //   else{
      if (
        this.selectedTrade.items[0].responseDocuments &&
        this.selectedTrade.items[0].responseDocuments.length
      ) {
        this.attachInformationFileList =
          this.selectedTrade.items[0].responseDocuments;
      } else {
        this.attachInformationFileList = [];
      }
      // }
    },
    uploadFile(file) {
      this.file = null;
      this.file = file;
      const loader = this.$loading.show();
      let fil = new FormData();
      fil.append('file', file);
      filesRepository()
        .sendFileWithoutFolderType(fil, this.fileBaseUrl)
        .then(({ data }) => {
          this.document.fileId = data.fileId;
          this.singleAttachedItem = {
            fileName: file.name,
          };
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    addFile(id) {
      if (
        this.postItems[id].documents &&
        this.document.fileId &&
        this.document.fileId.length &&
        this.document.documentTypeId &&
        this.document.documentTypeId.length
      ) {
        let fileUniqueId = uuid.v4();
        // this.form = {uniqueId:uniqueId, ... this.form}
        this.postItems[id].documents.push({
          categoryType: this.selectedTrade.category,
          documentTypeId: this.document.documentTypeId,
          fileId: this.document.fileId,
          description: this.document.description,
          expirationDateUtc: this.document.expirationDateUtc,
          fileUniqueId: fileUniqueId,
        });
        const key = 'fileUniqueId';
        this.postItems[id].documents = [
          ...new Map(
            this.postItems[id].documents.map((item) => [item[key], item])
          ).values(),
        ];

        this.attachInformationFileList.forEach((x) => {
          if (x.id == this.document.documentTypeId) {
            this.singleAttachedItem = {
              icon: 'mdi-close',
              description: this.document.description,
              type: x.title,
              documentTypeTitle: x.title,
              fileSize: this.file.size,
              fileType: this.file.type,
              fileUniqueId: fileUniqueId,

              ...this.singleAttachedItem,
            };
            x.color = 'success';
          }
        });

        this.attachedItems[id].push(this.singleAttachedItem);
        this.document = {
          documentTypeId: null,
          fileId: '',
          description: '',
          expirationDateUtc: '',
        };
        ///-------------------------------validation -----------------------------------////

        let ids = [];
        this.postItems[id].documents.forEach((x) => {
          ids.push(x.documentTypeId);
        });
        if (this.validationErr.validate) {
          this.attachInformationFileList.forEach((x) => {
            if (this.validationErr.validate && (x.required || !x.isOptional)) {
              if (!ids.includes(x.id)) {
                this.validationErr = {
                  validate: false,
                  errorMessage: 'برای تمام آیتم های اجباری مدارک آپلود کنید. ',
                };
                return;
              }
            }
          });
        } else {
          let flag = false;
          this.attachInformationFileList.forEach((x) => {
            if (!this.validationErr.validate && (x.required || !x.isOptional)) {
              if (!ids.includes(x.id)) {
                flag = false;
              } else {
                flag = true;
              }
            }
          });
          if (flag) {
            this.validationErr = { validate: true, errorMessage: '' };
          }
          //  }
        }
      }
    },
    removeAttachedItem(item) {
      let flag = true;
      if (this.$store.getters.tradeResponseIsEdit) {
        this.attachedItems[this.index].forEach((x, i) => {
          if (JSON.stringify(x) == JSON.stringify(item)) {
            this.attachedItems[this.index].splice(i, 1);
          }
        });
        this.postItems[this.index].documents.forEach((x, i) => {
          if (flag) {
            if (x.id && item.id && x.id == item.id) {
              this.postItems[this.index].documents.splice(i, 1);
              flag = false;
            } else if (
              x.fileUniqueId &&
              item.fileUniqueId &&
              x.fileUniqueId == item.fileUniqueId
            ) {
              this.postItems[this.index].documents.splice(i, 1);
              flag = false;
            }
          }
        });
      } else {
        this.attachedItems[this.index].forEach((x, i) => {
          if (JSON.stringify(x) == JSON.stringify(item)) {
            this.attachedItems[this.index].splice(i, 1);
          }
        });
        this.postItems[this.index].documents.forEach((x, i) => {
          if (
            x.fileUniqueId &&
            item.fileUniqueId &&
            x.fileUniqueId == item.fileUniqueId
          ) {
            this.postItems[this.index].documents.splice(i, 1);
          }
        });
      }

      //------------------------------validation -------------------------
      let ids = [];
      this.postItems[this.index].documents.forEach((x) => {
        ids.push(x.documentTypeId);
      });
      if (this.validationErr.validate) {
        this.attachInformationFileList.forEach((x) => {
          if (this.validationErr.validate && (x.required || !isOptional)) {
            if (!ids.includes(x.id)) {
              this.validationErr = {
                validate: false,
                errorMessage: 'برای تمام آیتم های اجباری مدارک آپلود کنید. ',
              };
              return;
            }
          }
        });
      }
    },

    validationError() {
      this.$dialog.error({
        text: 'وارد کردن موارد ستاره دار الزامی میباشد',
        title: 'خطا',
        persistent: true,
        actions: [
          {
            text: 'بستن',
            color: 'red',
          },
        ],
      });
    },

    viewReport() {
      // this.$store.commit("setTradeRequestSelectedItem", item);
      // this.selected = [item];
      this.reportData = this.$store.getters.tradeResponseProp;
      this.reportFlag = true;
    },
    acceptMerchantNotification(item) {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .tradeRequestMerchantNotificationAccept(
          this.$store.getters.tradeResponseMerchantNotificationId,
          { tradeRequestId: this.selectedTrade.id },
          this.tradeBaseUrl,
          { MerchantId: this.$store.getters.currentMerchant }
        )
        .then((res) => {
          this.$dialog.message.success(
            `  درخواست شما برای شرکت در
          ${this.tradeRequestDisplayName(this.selectedTrade.request)}
          با موفقیت ثبت شد. `,
            {
              position: 'top-left',
            }
          );
          this.getData();
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    rejectMerchantNotification(item) {
      const loader = this.$loading.show();
      tradeResponseRepository()
        .tradeRequestMerchantNotificationReject(
          this.$store.getters.tradeResponseMerchantNotificationId,
          { tradeRequestId: this.selectedTrade.id },
          this.tradeBaseUrl,
          { MerchantId: this.$store.getters.currentMerchant }
        )
        .then((res) => {
          this.$dialog.message.success(
            `  درخواست شما برای عدم شرکت در
          ${this.tradeRequestDisplayName(this.selectedTrade.request)}
          با موفقیت ثبت شد. `,
            {
              position: 'top-left',
            }
          );
          loader.hide();
          this.getData();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        })
        .finally(() => loader.hide());
    },
    setAllTermsConfirmedByMerchant(val) {
      this.postData.allTermsConfirmedByMerchant = val;
    },
    openDocumentModal(ind) {
      this.documentModal = true;
      this.index = ind;
    },
  },
};
</script>

<style scoped>
.mouse-over {
  cursor: pointer;
}
</style>
